import React, { FC, ReactElement } from 'react'
import { Skeleton } from '@material-ui/lab'

export const BrandingLoader: FC = (): ReactElement => (
    <div className='cmebt-loading'>
        <Skeleton />
        <div className='cmebt-loading-tabs'>
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
        </div>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
    </div>
)
